export default "__VITE_ASSET__Ogws5ikk__"